<div #viewport class="viewport" (scroll)="updateShadows()">
  <div #content class="content">
    <ng-content></ng-content>
  </div>
</div>
